module.exports = __webpack_public_path__ + "img/minecardSuccess.b09a6124.png";